module.exports = __webpack_public_path__ + "img/send-invites-desktop-fr.9fd5b46f.jpg";